import type { Message } from '@/types/messages.ts';

/** One chunk the knowledge-base search came back with. */
export interface KnowledgeBaseResult {
  id: string;
  document_id: string;
  file_name: string;
  content: string;
  similarity?: number;
  text_rank?: number;
  source?: 'vector' | 'text' | 'both';
}

/** Whether this turn is the knowledge-base search, which has a reading of its own. */
export function isKnowledgeBaseSearch(message: Message): boolean {
  return (
    message.type === 'tool_call' &&
    message.meta?.tool_call?.name === 'searchKnowledgeBase'
  );
}

/* The chunks the search answered with. Anything else in that body is not a result list. */
export function knowledgeBaseResults(message: Message): KnowledgeBaseResult[] {
  if (message.body.type !== 'text') return [];

  try {
    const parsed: unknown = JSON.parse(message.body.text);
    return Array.isArray(parsed) ? (parsed as KnowledgeBaseResult[]) : [];
  } catch {
    return [];
  }
}

/** What was searched for, as the tool call recorded it. */
export function knowledgeBaseQuery(message: Message): string {
  const query = message.meta?.tool_call?.args?.query;
  return typeof query === 'string' ? query : '';
}
